import type { FC } from 'react'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import {
  AnalyticsIcon,
  ParentIcon,
  CompliantIcon,
  FocusIcon,
  PiechartIcon,
  UserIcon,
} from '@segment/matcha/components/Icons/Brandbook'

import CardBase, * as Card from '@segment/matcha/recipes/Card'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const data = {
  title: `Key findings`,
  description: `Insightful takeaways from the report, at a glance.`,
  items: [
    {
      icon: <AnalyticsIcon size="large" />,
      title: `Consumer expectations are outpacing experiences`,
      description: `While 85% of the businesses studied by Twilio Segment believe they are offering personalized experiences, only 60% of consumers seem to think that’s the case.`,
      href: `https://segment.com/#content-1`,
    },
    {
      icon: <ParentIcon size="large" />,
      title: `Customer loyalty is on the line`,
      description: `If brands fail to offer a personalized experience, 45% of consumers say they’re likely to take their business elsewhere.`,
      href: `https://segment.com/#content-1-1`,
    },
    {
      icon: <CompliantIcon size="large" />,
      title: `Personalization and privacy aren’t mutually exclusive`,
      description: `69% of consumers say they appreciate personalization, so long as it’s based on data they’ve shared with a business directly.`,
      href: `https://segment.com/#content-2`,
    },
    {
      icon: <FocusIcon size="large" />,
      title: `Personalization requires good data`,
      description: `43% of organizations see accurate, real-time customer data as the biggest challenge to their personalization efforts.`,
      href: `https://segment.com/#content-d1-1`,
    },
    {
      icon: <PiechartIcon size="large" />,
      title: `Omnichannel barriers`,
      description: `75% of businesses are failing to deliver omnichannel personalization, with departmental silos and legacy infrastructure the key barriers to success.`,
      href: `https://segment.com/#content-d2`,
    },
    {
      icon: <UserIcon size="large" />,
      title: `The future is first-party`,
      description: `80% of businesses say they are using at least some first-party data to personalize the customer experience.`,
      href: `https://segment.com/#content-2-2`,
    },
  ],
}

const KeyFindings: FC = () => {
  return (
    <SectionBase variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h3" variant="h2">
            {data.title}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {data.description}
          </CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <ColumnTrack
          overrides={{
            md: 2,
            xl: 3,
          }}
        >
          {data.items.map(({ icon, title, description, href }, key) => (
            <CardBase href={href} key={key}>
              <Card.Body>
                <Card.Accessories>
                  <Card.AccessoriesRow>{icon}</Card.AccessoriesRow>
                </Card.Accessories>
                <Card.Copy>
                  <Card.Headline>{title}</Card.Headline>
                  <Card.Description>{description}</Card.Description>
                </Card.Copy>
                <Card.Action alignment="right">
                  <ChevronRightIcon />
                </Card.Action>
              </Card.Body>
            </CardBase>
          ))}
        </ColumnTrack>
      </Section.Contents>
    </SectionBase>
  )
}

export default KeyFindings
